import type { Listing } from '@thevillages/schemas';

import type { ListingsService } from '../listings';

export function Beds(this: ListingsService, listing: Listing, currentValue: boolean): boolean {
  // If no value is set, do not affect the filter.
  if (!this.filteringService.beds().length) {
    return currentValue;
  }

  const _beds: number[] = [];
  if (listing.beds) {
    _beds.push(listing.beds);
  }
  if (listing.customFilters?.beds) {
    _beds.push(listing.customFilters.beds);
  }

  // If the listing does not have a value, exclude it from results.
  if (!_beds.length) {
    return false;
  }

  const _values = [...this.filteringService.beds()];

  // Add more values if the user selected 4+ for the filter.
  if (this.filteringService.beds().includes('4')) {
    _values.push('5');
    _values.push('6');
    _values.push('7');
  }

  // Determine if the listing matches the filter.
  const _value = _values.map((b) => parseInt(b, 10));
  if (!_value.some((v) => _beds.includes(v))) {
    return false;
  }

  // If the listing does not match the filter, do not affect the filter.
  return currentValue;
}
